/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_itinerary__options__modes__car_ev_limit_warning_message = /** @type {(inputs: {}) => string} */ () => {
	return `Verschiedene Faktoren (Temperatur, Wind, Anzahl der Passagiere...) können die Reichweite Ihres E-Autos beeinflussen. Wir empfehlen, einen Puffer einzuplanen.`
};

const en_itinerary__options__modes__car_ev_limit_warning_message = /** @type {(inputs: {}) => string} */ () => {
	return `Variables (temperature, wind, number of passengers, etc.) can affect the range of your electric vehicle. Remember to leave a little margin!`
};

const es_itinerary__options__modes__car_ev_limit_warning_message = /** @type {(inputs: {}) => string} */ () => {
	return `Variables como la temperatura, el viento o el número de pasajeros pueden tener un impacto sobre la autonomía de tu vehículo eléctrico. Acuérdate de prever un margen de maniobra suficiente.`
};

const fr_itinerary__options__modes__car_ev_limit_warning_message = /** @type {(inputs: {}) => string} */ () => {
	return `Des variables (température, vent, nombre de passagers...) peuvent affecter l’autonomie de votre véhicule électrique. Pensez à garder un peu de marge !`
};

const it_itinerary__options__modes__car_ev_limit_warning_message = /** @type {(inputs: {}) => string} */ () => {
	return `Alcune variabili (temperatura, vento, numero di passeggeri, ecc.) possono influenzare l’autonomia del veicolo elettrico. Prevedi sempre un po’ di autonomia in più!`
};

const nl_itinerary__options__modes__car_ev_limit_warning_message = /** @type {(inputs: {}) => string} */ () => {
	return `Variabelen (temperatuur, wind, aantal passagiers, enz.) kunnen het bereik van uw elektrische voertuig beïnvloeden. Vergeet niet om een kleine marge te houden!`
};

const pt_itinerary__options__modes__car_ev_limit_warning_message = /** @type {(inputs: {}) => string} */ () => {
	return `A autonomia do seu veículo elétrico pode ser afetada por variáveis (temperatura, vento, número de passageiros...). Lembre-se de manter um pouco de margem!`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__modes__car_ev_limit_warning_message = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.itinerary__options__modes__car_ev_limit_warning_message(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("itinerary__options__modes__car_ev_limit_warning_message", locale)
	if (locale === "de") return de_itinerary__options__modes__car_ev_limit_warning_message(inputs)
	if (locale === "en") return en_itinerary__options__modes__car_ev_limit_warning_message(inputs)
	if (locale === "es") return es_itinerary__options__modes__car_ev_limit_warning_message(inputs)
	if (locale === "fr") return fr_itinerary__options__modes__car_ev_limit_warning_message(inputs)
	if (locale === "it") return it_itinerary__options__modes__car_ev_limit_warning_message(inputs)
	if (locale === "nl") return nl_itinerary__options__modes__car_ev_limit_warning_message(inputs)
	return pt_itinerary__options__modes__car_ev_limit_warning_message(inputs)
};